export default __webpack_public_path__ + "media/onboarding/customize-a986113b.gif";